/**
 * The Method page's data (IP2b), as GET /api/method serves it (server/src/method/catalogue.ts): the rule cards
 * (rule-card.v1, after Valentin's P2b) with their rule files, the prompt library and the rules without a card yet.
 */

export interface Bilingual {
  en: string
  sv: string
}

export type Json = null | boolean | number | string | Json[] | { [key: string]: Json }

export type RuleArea = 'engine' | 'business' | 'pictures' | 'findings' | 'modules'

export interface RuleCard {
  schema: 'rule-card.v1'
  id: string
  scoped_id: string
  area: RuleArea
  name: Bilingual
  decides: Bilingual
  code: string
  sql: string | null
  formula: Bilingual
  inputs: { name: string; en: string; sv: string }[]
  example: { text: Bilingual; cases: { input: Json; output: Json }[] }
  sources: { ref: string; note: Bilingual | null }[]
  file: { path: string; sha256: string; version: number; status: string; decision: Bilingual | null; text: string } | null
}

export interface MethodView {
  rules: RuleCard[]
  prompts: string[]
  /** The rules without a card yet: named in words, with their id and file as code. */
  later: { id: string; scoped_id: string; code: string; name: Bilingual }[]
}

/** The areas in the page's order: how a level is reached, the profile it rests on, the pictures, the findings, then the modules from ANTON (IP10a). */
export const AREA_ORDER: readonly RuleArea[] = ['engine', 'business', 'pictures', 'findings', 'modules']

/** The cards grouped by area, in the page's order; within an area, as the server lists them. */
export function byArea(rules: readonly RuleCard[]): { area: RuleArea; rules: RuleCard[] }[] {
  return AREA_ORDER.map((area) => ({ area, rules: rules.filter((r) => r.area === area) })).filter((g) => g.rules.length > 0)
}

/** The anchor of a rule's card on the page, e.g. `rule-heat.v1`. */
export function ruleAnchor(id: string): string {
  return `rule-${id}`
}

/** The page's address for one rule's card. */
export function methodLink(id: string): string {
  return `/about/method#${ruleAnchor(id)}`
}
